export default __webpack_public_path__ + "static/help_02_06-1d1f3295c6e4b7dca0ecbc1cadb3ec95.png";